import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=5da66ac7&scoped=true&"
import script from "./TaskList.vue?vue&type=script&lang=ts&"
export * from "./TaskList.vue?vue&type=script&lang=ts&"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=5da66ac7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da66ac7",
  null
  
)

export default component.exports